var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 121,
    viewBox: "0 0 64 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3227 89.0439C63.3227 106.266 48.9074 120.7 31.6663 120.7C14.4253 120.7 0.0100098 106.285 0.0100098 89.0439C0.0100098 75.7169 8.67826 64.1083 17.3656 60.6907C8.69735 57.273 0.0100098 45.6644 0.0100098 32.3374C0.0100098 15.1155 14.4253 0.700195 31.6663 0.700195C48.9074 0.700195 63.3227 15.1155 63.3227 32.3374C63.3227 45.6644 54.6544 57.2539 45.9671 60.6907C54.6353 64.1083 63.3227 75.7169 63.3227 89.0439ZM31.5518 57.3875H31.6663C45.7188 54.9436 56.7164 46.3899 56.7164 32.3374C56.7164 18.2849 45.7188 7.17275 31.6663 7.17275C17.6138 7.17275 6.50164 18.2849 6.50164 32.3374C6.50164 46.3899 17.6138 57.3875 31.5518 57.3875ZM56.7164 89.0439C56.7164 74.9914 45.7188 63.9938 31.6663 63.9938H31.5518C17.6138 63.9938 6.50164 74.9914 6.50164 89.0439C6.50164 103.096 17.6138 114.209 31.6663 114.209C45.7188 114.209 56.7164 103.096 56.7164 89.0439Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber8);
export default __webpack_public_path__ + "static/media/NUMBER_8.98dc67066de64c6091613a15cf19823e.svg";
export { ForwardRef as ReactComponent };